import React from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";

class FinancialInformation extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
              <CardBody>
              <Row>
                    <Col sm="6">
                      <div className="typography-line">
                        <h4>
                          <span>Basic Monthly Salary</span>
                          {client.salary || "N/A"}
                        </h4>
                      </div>
                      {client.civil_status === "Married" ? (
                        <div className="typography-line">
                          <h4>
                            <span>Spouse Salary</span>
                            {client.spouseSalary || "N/A"}
                          </h4>
                        </div>
                      ) : null}
                      <div className="typography-line">
                        <h4>
                          <span>Co-Borrower Salary</span>
                          {client.coBorrowerSalary || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Overtime</span>
                          {client.overtime || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Allowances</span>
                          {client.allowances || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Others</span>
                          {client.otherIncome || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Total</span>
                          {client.total || "N/A"}
                        </h4>
                      </div>
                    </Col>
                    <Col sm="6">
                      <div className="typography-line">
                        <h4>
                          <span>Financing Type</span>
                          {client.financingType || "N/A"}
                        </h4>
                      </div>

                      <div className="typography-line">
                        <h4>
                          <span>Financing Subtype</span>
                          {client.financingSubtype || "N/A"}
                        </h4>
                      </div>
                    </Col>
              </Row>
                
              </CardBody>
            </Card>
        )
    }
}

export default FinancialInformation;